import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';
import HotRankPanel from '@/pages/home/components/HotRankPanel';
import { articles } from '@/mocks/articles';

const LatestFeed = () => {
  const feed = articles.filter((article) => article.id !== 'a-1001').slice(0, 6);

  return (
    <section className="border-y border-background-200/70 bg-background-100/40 py-12 md:py-16" aria-labelledby="latest-heading">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          <div>
            <SectionHeading
              eyebrow="刚挖出来的料"
              title="最新爆料"
              desc="按发布时间排序的内部首发内容，打开即可读到完整分析。"
              action={
                <Link
                  to="/topics"
                  className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-primary-600 hover:text-primary-700"
                >
                  进入爆料库
                  <i className="ri-arrow-right-line text-base"></i>
                </Link>
              }
            />
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              {feed.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>

          <HotRankPanel />
        </div>
      </div>
    </section>
  );
};

export default LatestFeed;